<template functional>
  <v-btn
    dark
    width="140px"
    :to="props.to"
    height="40px"
    color="eventResultsBtn"
    :class="props.marginClass"
    v-bind="attrs"
  >
    {{ parent.$t("common:results.button") }}
  </v-btn>
</template>
<script>
export default {
  name: "AppShowResultsBtn",
  props: {
    to: {
      type: Object,
      default: undefined
    },
    marginClass: {
      type: String,
      default: undefined
    }
  }
};
</script>
